//HoC for check authentication
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Loader from "../layout/loader";
import {useAuth} from "../../hooks/useAuth.js";
import { ADMIN_ACCESS } from "../../utils/constants.js";

import { canAccessRoute } from "../../utils/routeAccess";

const ProtectedRoute = ({children, requiresAdmin = false})  => {

    const location = useLocation();
    const {loading, isAuthenticated, user} = useAuth();

    // Handle loading state
    if (loading) return <Loader />;

    // Check authentication status
    if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;

    const home = user?.subAccount ? '/thd' : '/';
    if (!canAccessRoute(user, location.pathname) || (requiresAdmin && user?.access !== ADMIN_ACCESS)) {
        return <Navigate to={home} state={{ from: location }} replace />;
    }

    return children;
}

export default ProtectedRoute;